/* tslint:disable:max-classes-per-file */

import { Exception } from '@amzn/ihm-associate-tools-js-lib'

export class IhmLoginNotLoggedInException extends Exception {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalException extends Exception {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalRetryableException extends IhmLoginTokenRetrievalException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalNonRetryableException extends IhmLoginTokenRetrievalException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalNetworkingException extends IhmLoginTokenRetrievalRetryableException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalInternalServerErrorException extends IhmLoginTokenRetrievalRetryableException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalUnknownErrorException extends IhmLoginTokenRetrievalRetryableException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalStateMismatchException extends IhmLoginTokenRetrievalNonRetryableException {
    constructor (args) {
        super(args)
    }
}

export class IhmLoginTokenRetrievalClientErrorException extends IhmLoginTokenRetrievalNonRetryableException {
    constructor (args) {
        super(args)
    }
}
